import Button from "@/components/ui/button";
import StepLayout from "../step-layout";
import { useFeedbackFlow } from "../../hooks/use-feedback-flow";

export default function StepMotivation() {
	const { nextStep } = useFeedbackFlow();

	return (
		<StepLayout
			header={
				<div className="mb-6">
					<h1 className="text-2xl font-semibold text-primary mb-2">Thank you for your feedback!</h1>
					<p className="text-secondary">We'd love to hear more about your experience.</p>
				</div>
			}
			content={
				<div className="text-left">
					<h2 className="text-lg font-medium text-primary mb-3">Why does your feedback matter?</h2>
					<p className="text-secondary mb-4">
						Your testimonial helps other people discover our product and understand how it can help them. It also motivates our team to keep building and improving.
					</p>
					<p className="text-secondary">In the next few steps, we'll ask you a few quick questions. It only takes a couple of minutes, and your words will make a real difference.</p>
				</div>
			}
			footer={
				<div className="flex justify-center">
					<Button onClick={nextStep} variant="brand" className="w-full">
						Continue
					</Button>
				</div>
			}
		/>
	);
}
